import React from 'react'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { PendingAppointmentsTable } from './PendingAppointmentsTable'
import { TSchedulingTabOnHoldStops } from './types'

interface IPendingAppointmentsModalProps extends Omit<IModalBaseProps, 'modalType'> {
  onCancel: () => void
  onHoldStops: TSchedulingTabOnHoldStops
}

export const PendingAppointmentsModal = ({
  onHoldStops,
  open = false,
  ...props
}: IPendingAppointmentsModalProps) => (
  <ModalBase
    dataTest='PendingAppointmentsModal'
    modalType={MODAL_TYPES.form}
    size={12}
    open={open}
    fullHeight
    isClose
    title='Pending Appointments for this Facility'
    {...props}>
    <PendingAppointmentsTable items={onHoldStops} />
  </ModalBase>
)
